var map = {
	"./AssessmentReport.svg": 452,
	"./Daily.svg": 453,
	"./EnrolledPatientReport.svg": 454,
	"./Failed.svg": 89,
	"./Ghana.svg": 455,
	"./Info-blue.svg": 218,
	"./Info-green.svg": 217,
	"./Kenya.svg": 456,
	"./MOH.svg": 457,
	"./PatientDuplicateReport.svg": 458,
	"./PatientStatusReport.svg": 459,
	"./Pending.svg": 219,
	"./Permanent.svg": 460,
	"./Presc.svg": 461,
	"./ScreenedReport.svg": 462,
	"./Sierra Leone.svg": 463,
	"./Spice.svg": 220,
	"./SpiceEngage.svg": 221,
	"./Tanzania.svg": 464,
	"./US.svg": 465,
	"./UserPerformance.svg": 466,
	"./app-logo.svg": 74,
	"./arrow-right-small.svg": 467,
	"./assignQuickSightUser.svg": 222,
	"./avatar-o.svg": 468,
	"./bin.svg": 223,
	"./caret-down-grey.svg": 215,
	"./caret-down-white.svg": 469,
	"./checkbox-disabled.svg": 224,
	"./checkbox-empty.svg": 172,
	"./checkbox.svg": 173,
	"./close.svg": 225,
	"./download.svg": 130,
	"./dropdown.svg": 226,
	"./edit.svg": 131,
	"./hidePass.svg": 113,
	"./home.svg": 227,
	"./info-grey.svg": 470,
	"./info-orange.svg": 216,
	"./insights.svg": 228,
	"./no-icon.svg": 305,
	"./plus.svg": 229,
	"./power-switch.svg": 214,
	"./quickSightUser.svg": 230,
	"./reports.svg": 231,
	"./reset.svg": 232,
	"./search.svg": 233,
	"./send-disabled.svg": 234,
	"./send.svg": 235,
	"./showPass.svg": 82,
	"./success-blue.svg": 132,
	"./success-green.svg": 236,
	"./tick.svg": 237,
	"./user-role-assigned.svg": 238,
	"./user-role-not-assigned.svg": 129,
	"./warning.svg": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;